var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0637 21.1571C10.6404 21.1571 11.108 20.7266 11.108 20.1956C11.108 19.6646 10.6404 19.2341 10.0637 19.2341C9.48704 19.2341 9.01953 19.6646 9.01953 20.1956C9.01953 20.7266 9.48704 21.1571 10.0637 21.1571Z",
    stroke: "white",
    strokeWidth: 1.92292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5501 21.1571C22.1268 21.1571 22.5943 20.7266 22.5943 20.1956C22.5943 19.6646 22.1268 19.2341 21.5501 19.2341C20.9734 19.2341 20.5059 19.6646 20.5059 20.1956C20.5059 20.7266 20.9734 21.1571 21.5501 21.1571Z",
    stroke: "white",
    strokeWidth: 1.92292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70996 0.966736H5.8868L8.68529 13.8407C8.78078 14.2834 9.04231 14.681 9.42412 14.964C9.80592 15.247 10.2837 15.3973 10.7737 15.3887H20.9234C21.4135 15.3973 21.8912 15.247 22.273 14.964C22.6548 14.681 22.9164 14.2834 23.0119 13.8407L24.6826 5.77405H6.93102",
    stroke: "white",
    strokeWidth: 1.92292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8fb7470c3d1b5af97e7319e376fe93af.svg";
export { ForwardRef as ReactComponent };